import * as Sentry from '@sentry/browser';
import { Integrations } from '@sentry/tracing';
import { getEnvDomain, getUrl, getHost } from '../../utils/domain';
import { _send, _setup, _close, _addTags, SDK_VERSION } from '../../sdk';
import { setTagValue } from '../../utils/tags';
/**
 * 监控sdk注册/安装方法，参数可选有效的dsn或者包含dsn key值的对象
 * @param options dsn: string | { dns: string }
 */
export function setup(options) {
    var defaultOptions = {
        integrations: [new Integrations.BrowserTracing({
                tracingOrigins: [getHost()]
            })],
        wjTags: {
            tracker_sdk_platform: 'browser',
            service_url: getUrl()
        },
        environment: getEnvDomain(),
        beforeSend: function (ev) {
            // 针对单页面应用的路由可能改变，需要主动更新 tag service_url
            try {
                setTagValue(ev.tags, 'service_url', getUrl(), 'global');
            }
            finally { }
            ;
            return ev;
        }
    };
    /* 必须传参数 */
    _setup(Sentry, options, defaultOptions);
}
/**
 * 该方法用来手动发送错误，支持两个参数，第一个参数必传（错误信息），第二个参数可选（本次错误附带的标签tag信息 wj_user_{tagKey}）
 * @param error Error | string 支持错误对象 或者 错误信息(会包装成Error对象)
 * @param extra  \{ tags : { [ tagKey: sting ]: string } }
 */
export function send(error, extra) {
    _send(Sentry, error, extra);
}
/**
 * 该方法用来补充全局标签 wj_global_{tagKey}
 * @param tags \{ [ tagKey: sting ]: string }
 */
export function addTags(tags) {
    _addTags(Sentry, tags);
}
/**
 * 手动关闭监控sdk
 * @param time number: 关闭监控的时间 单位:ms
 */
export function close(time) {
    return _close(Sentry, time);
}
export var version = SDK_VERSION;
export { Sentry };
//# sourceMappingURL=index.js.map